import React from 'react'
import { navigate } from 'gatsby'

import { useUser } from '~config/user-provider'
import LoadingView from '~components/shared/loading-view'

const IndexPage = () => {
    const { loading } = useUser()

    if (loading) {
        return <LoadingView />
    }

    navigate('/home')

    return null
}

export default IndexPage
